import { render, staticRenderFns } from "./TicketBuyNoticePopup.vue?vue&type=template&id=fce1785e&scoped=true&"
import script from "./TicketBuyNoticePopup.vue?vue&type=script&lang=js&"
export * from "./TicketBuyNoticePopup.vue?vue&type=script&lang=js&"
import style0 from "./TicketBuyNoticePopup.vue?vue&type=style&index=0&id=fce1785e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce1785e",
  null
  
)

export default component.exports